<template>
  <section class="business-logic">
    <Breadcrumbs
      :breadcrumbs="[
        {title: $t('menu.configurations'), disabled: true},
        {title: $t('menu.business-logic'), disabled: true}
      ]">
    </Breadcrumbs>

    <div class="evollu-form">
      <div class="row mt-3">
        <va-input
          class="col-6 col-md-6"
          id="pharmacies-universe"
          :label="$t('configurations.business.pharmacies_universe')"
          v-model.number="form.data.pharmacies_universe"
          type="number"
          :placeholder="$t('configurations.business.pharmacies_universe')"
          @input="form.errors.clear('pharmacies_universe')"
          :error="form.errors.has('pharmacies_universe')"
          :error-messages="[$t(form.errors.get('pharmacies_universe'))]"
        />
      </div>
    </div>
  </section>
</template>

<script>
import Breadcrumbs from "@/components/common/Breadcrumbs";
import Errors from "@/utils/CustomHomelabErrors";
import {BusinessLogicService} from "@/api/AuthService";

export default {
  components: {Breadcrumbs},
  data: function () {
    return {
      canSubmit: false,
      form: {
        data: {
          pharmacies_universe: null
        },
        errors: new Errors()
      }
    }
  },
  async mounted() {
    let data = await BusinessLogicService.get()
    this.form.data = {...data}
  },
  methods: {
    async handleSubmit() {
      let data = {... this.form.data}
      try {
        let resp = await BusinessLogicService.post(data)
        this.showToast(this.$t('configurations.business.values_submited'), this.$store.state.successToastOptions)
      } catch (err) {
        console.log(err)
        this.showToast(this.$t('configurations.business.values_submited_error'), this.$store.state.errorToastOptions)
      }
    }
  },
  watch: {
    'form.data.pharmacies_universe': function (val) {
      this.canSubmit = val !== null && val > 0
    },
  }
}
</script>
